import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { distinctUntilChanged, skip, tap } from 'rxjs/operators';
import { merge, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../../../core/reducers';
import {
  LayoutUtilsService,
  MessageType,
  QueryParamsModel,
} from '../../../../../../core/_base/crud';
import { TranslateService } from '@ngx-translate/core';
import { SubheaderService } from '../../../../../../core/_base/layout';
import {
  ClearMemberState,
  selectTeamMemberError,
  TeamMember,
  TeamMembersDataSource,
  TeamMembersPageRequested,
} from '../../../../../../core/lists';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-team-members-list',
  templateUrl: './team-members-list.component.html',
  styleUrls: ['./team-members-list.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamMembersListComponent implements OnInit, OnDestroy {
  dataSource: TeamMembersDataSource;
  displayedColumns = ['id', 'profile', 'firstName'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('sort', { static: true }) sort: MatSort;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  teamMembersResult: TeamMember[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TeamMembersListComponent>,
    public dialog: MatDialog,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private translate: TranslateService,
    public subheaderService: SubheaderService,
  ) {}

  ngOnInit() {
    this.loadTeamMembersList();
    const sortSubscription = this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.sort.active = this.sort.direction ? this.sort.active : 'created_at';
      this.sort.direction = this.sort.direction || 'desc';
    });
    this.subscriptions.push(sortSubscription);
    const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page)
      .pipe(tap(() => this.loadTeamMembersList()))
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);
    this.dataSource = new TeamMembersDataSource(this.store);
    const entitiesSubscription = this.dataSource.entitySubject
      .pipe(skip(1), distinctUntilChanged())
      .subscribe((res) => {
        this.teamMembersResult = res;
      });
    this.subscriptions.push(entitiesSubscription);
    const errorSubscription = this.store
      .pipe(select(selectTeamMemberError), skip(1))
      .subscribe((res) => {
        if (res) {
          this.layoutUtilsService.showActionNotification(
            this.translate.instant('GLOBAL.UNSPECIFIED_ERROR'),
            MessageType.Update,
            3000,
            true,
            false,
          );
        }
      });
    this.subscriptions.push(errorSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.store.dispatch(new ClearMemberState());
  }

  loadTeamMembersList() {
    const queryParams = new QueryParamsModel(
      {},
      this.sort.direction || 'desc',
      this.sort.active || 'created_at',
      this.paginator.pageIndex,
      this.paginator.pageSize,
    );
    this.store.dispatch(
      new TeamMembersPageRequested({
        page: queryParams,
        category_id: this.data.category_id,
        category_name: this.data.name,
      }),
    );
  }
}
